const lan = {
    "inFace-zh-Hans":{
        "title":"inFace产品汪",
		"subtitle": "杜若尘",
		"desc":"inFace的每一点进步都离不开你的支持与反馈。快来提点建议吧，玩的不爽也可以尽情吐槽。之后的升级一定会让你惊喜的~",
		"placeholder":"有啥说啥，欢迎调戏~",
        "contact":"联系方式",
        "type":"（微信、QQ或手机号）",
		"contactPlaceholder":"请留下您的联系方式",
        "submit":"发送",
        "sending": '发送中',
        "done": "我知道了",
        "close": "关闭",
        "thank": "感谢反馈",
        "fail":'发送失败',
        "welfareGroup":"进入inFace福利群",
        "copy":"(点击复制)",
        "money":"进群反馈秒处理，更有红包送不停",
        "addService":"QQ：",
        "qq":"588983000"
    },
    "zh-Hans":{
		"title":"沙拉产品汪",
		"subtitle": "巫若尘",
		"desc":"沙拉的每一点进步都离不开你的支持与反馈。快来提点建议吧，玩的不爽也可以尽情吐槽。之后的升级一定会让你惊喜的~",
		"placeholder":"有啥说啥，欢迎调戏~",
        "contact":"联系方式",
        "type":"（微信、QQ或手机号）",
		"contactPlaceholder":"请留下您的联系方式",
        "submit":"发送",
        "sending": '发送中',
        "done": "我知道了",
        "close": "关闭",
        "thank": "感谢反馈",
        "fail":'发送失败',
        "welfareGroup":"进入沙拉福利群",
        "copy":"(点击复制)",
        "money":"进群反馈秒处理，更有红包送不停",
        "addService":"添加微信客服：",
        "qq":"xzhao0911"
	},
    "inFace-zh-Hant":{
        "title":"inFace產品汪",
		"subtitle": "杜若塵",
		"desc":"inFace的每一點進步都離不開你的支持與反饋。快來提點建議吧，玩的不爽也可以盡情吐槽。之後的升級一定會讓你驚喜的~",
		"placeholder":"有啥說啥，歡迎調戲~",
        "contact":"聯繫方式",
        "type":"（微信、QQ或手機號）",
		"contactPlaceholder":"請留下您的聯繫方式",
        "submit":"發送",
        "sending": '發送中',
        "done": "我知道了",
        "close": "關閉",
        "thank": "感謝反饋",
        "fail":'發送失敗',
        "welfareGroup":"進入inFace福利群",
        "copy":"(點擊複製)",
        "money":"進群反饋秒處理，更有紅包送不停",
        "addService":"QQ：",
        "qq":"588983000"
    },
    "zh-Hant":{
		"title":"沙拉產品汪",
		"subtitle": "巫若塵",
		"desc":"沙拉的每一點進步都離不開你的支持與反饋。快來提點建議吧，玩的不爽也可以盡情吐槽。之後的升級一定會讓你驚喜的~",
		"placeholder":"有啥說啥，歡迎調戲~",
        "contact":"聯繫方式",
        "type":"（微信、QQ或手機號）",
		"contactPlaceholder":"請留下您的聯繫方式",
        "submit":"發送",
        "sending": '發送中',
        "done": "我知道了",
        "close": "關閉",
        "thank": "感謝反饋",
        "fail":'發送失敗',
        "welfareGroup":"進入沙拉福利群",
        "copy":"(點擊複製)",
        "money":"進群反饋秒處理，更有紅包送不停",
        "addService":"添加微信客服：",
        "qq":"xzhao0911"
	},
    "inFace-en":{
        "title":"inFace product mascot",
        "subtitle": "Bob",
        "desc":"Every improvement in the product cannot be achieved without your support and feedback. Come and make some suggestions. If you are not happy, you can also roast us. After the upgrade we will definitely surprise you~",
        "placeholder":"Feel free to say everything!",
        "contact":"contact",
        "type":"（E-mail）",
        "contactPlaceholder":"Please leave your contact information",
        "submit":"send",
        "sending": 'sending',
        "done": "Duly noted",
        "close": "Close",
        "thank": "Thank you for your feedback!",
        "fail":'Failed to send',
        "welfareGroup":"Enter the inFace welfare group",
        "copy":"(Click copy)",
        "money":"Group feedback is processed in seconds, and red envelopes are sent non-stop",
        "addService":"QQ：",
        "qq":"588983000"
    },
    "en":{
        "title":"Salad Video product mascot",
        "subtitle": "Warming",
        "desc":"Every improvement in the product cannot be achieved without your support and feedback. Come and make some suggestions. If you are not happy, you can also roast us. After the upgrade we will definitely surprise you~",
        "placeholder":"Feel free to say everything!",
        "contact":"contact",
        "type":"（E-mail）",
        "contactPlaceholder":"Please leave your contact information",
        "submit":"send",
        "sending": 'sending',
        "done": "Duly noted",
        "close": "Close",
        "thank": "Thank you for your feedback!",
        "fail":'Failed to send',
        "welfareGroup":"Enter the Sara welfare group",
        "copy":"(Click copy)",
        "money":"Group feedback is processed in seconds, and red envelopes are sent non-stop",
        "addService":"Add WeChat customer service：",
        "qq":"xzhao0911"
    },
    "inFace-ja":{
        "title":"製品マスコットのSalad Video",
		"subtitle": "Bob",
		"desc":"製品の改善には、お客様のご支援とご意見が不可欠です。お客様のご意見をお聞かせください。また、ご満足いただけない場合にも、ぜひ率直な声をお聞かせください。アップグレード後のサプライズをお楽しみに！",
		"placeholder":"お気軽にご連絡ください。",
        "contact":"連絡先",
        "type":"（E-mail）",
		"contactPlaceholder":"連絡先情報を残してください",
        "submit":"送信する",
        "sending": '送信中',
        "done": "今後の参考にさせていただきます。",
        "close": "閉じる",
        "thank": "フィードバックをありがとうございます",
        "fail":'送信に失敗しました',
        "welfareGroup":"inFace福祉グループに入る",
        "copy":"(コピーをクリックします)",
        "money":"グループフィードバックは数秒で処理され、赤い封筒がノンストップで送信されます",
        "addService":"QQ：",
        "qq":"588983000"
    },
    "ja":{
        "title":"製品マスコットのSalad Video",
		"subtitle": "Warming",
		"desc":"製品の改善には、お客様のご支援とご意見が不可欠です。お客様のご意見をお聞かせください。また、ご満足いただけない場合にも、ぜひ率直な声をお聞かせください。アップグレード後のサプライズをお楽しみに！",
		"placeholder":"お気軽にご連絡ください。",
        "contact":"連絡先",
        "type":"（E-mail）",
		"contactPlaceholder":"連絡先情報を残してください",
        "submit":"送信する",
        "sending": '送信中',
        "done": "今後の参考にさせていただきます。",
        "close": "閉じる",
        "thank": "フィードバックをありがとうございます",
        "fail":'送信に失敗しました',
        "welfareGroup":"サラ福祉グループに入る",
        "copy":"(コピーをクリックします)",
        "money":"グループフィードバックは数秒で処理され、赤い封筒がノンストップで送信されます",
        "addService":"WeChatカスタマーサービスを追加します。",
        "qq":"xzhao0911"
    },
    "inFace-es-US":{
        "title":"샐러드 비디오의 매니저",
		"subtitle": "Bob",
		"desc":"제품의 매 하나의 개선은 당신의 지지와 피드백을 떠날 수 없습니다.이리 와서 건의를 좀 해 봐.만약 네가 좋아하지 않더라도 너는 우리를 비웃을 수 있다.업데이트 시켜서 깜짝 놀래드릴게요.",
		"placeholder":"함부로 말해봐!",
        "contact":"연락처",
        "type":"（E-mail）",
		"contactPlaceholder":"연락처 남겨주세요",
        "submit":"보내기",
        "sending": '보내는 중',
        "done": "알겠습니다",
        "close": "닫기",
        "thank": "피드백에 감사하다",
        "fail":'보내기 실패',
        "welfareGroup":"inFace 복지 그룹 입력",
        "copy":"(클릭 복사)",
        "money":"그룹 피드백은 몇 초 만에 처리되며 빨간색 봉투가 중단없이 전송됩니다",
        "addService":"QQ：",
        "qq":"588983000"
    },
    "es-US":{
        "title":"샐러드 비디오의 매니저",
		"subtitle": "Warming.",
		"desc":"제품의 매 하나의 개선은 당신의 지지와 피드백을 떠날 수 없습니다.이리 와서 건의를 좀 해 봐.만약 네가 좋아하지 않더라도 너는 우리를 비웃을 수 있다.업데이트 시켜서 깜짝 놀래드릴게요.",
		"placeholder":"함부로 말해봐!",
        "contact":"연락처",
        "type":"（E-mail）",
		"contactPlaceholder":"연락처 남겨주세요",
        "submit":"보내기",
        "sending": '보내는 중',
        "done": "알겠습니다",
        "close": "닫기",
        "thank": "피드백에 감사하다",
        "fail":'보내기 실패',
        "welfareGroup":"사라 복지 그룹에 들어가십시오",
        "copy":"(클릭 복사)",
        "money":"그룹 피드백은 몇 초 만에 처리되며 빨간색 봉투가 중단없이 전송됩니다",
        "addService":"WeChat 고객 서비스 추가：",
        "qq":"xzhao0911"
    }
}

export default lan



// WEBPACK FOOTER //
// ./src/common/lan.js